import { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../../../utils/constants";
import { toast } from "react-toastify";
import { IoArrowForward, IoKeyOutline, IoCheckmarkOutline } from "react-icons/io5";
import "../auth.css";

function PasswordOtpPage() {
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const inputsRef = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, "");
    if (!value) return;
    const newOtp = [...otp];
    newOtp[index] = value.charAt(0);
    setOtp(newOtp);
    if (index < 5) inputsRef.current[index + 1]?.focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        setOtp(prev => { const n = [...prev]; n[index] = ""; return n; });
      } else if (index > 0) {
        inputsRef.current[index - 1].focus();
      }
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("Text").trim().slice(0, 6);
    if (!/^\d+$/.test(paste)) return;
    const chars = paste.split("");
    setOtp(prev => prev.map((_, i) => chars[i] || ""));
    inputsRef.current[Math.min(chars.length, 5)]?.focus();
  };

  const verifyOTP = async () => {
    const response = await fetch(API_URL + '/password/otp', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        phone_number: location?.state?.phoneNumber,
        otp: otp.join(""),
      }),
    });
    const data = await response.json();
    if (data.success) {
      navigate("/password_recovery/new", {
        state: { phoneNumber: location?.state?.phoneNumber, otp: otp.join("") }
      });
    } else {
      toast.error(data.message || "رمز غير صحيح");
    }
  };

  const isFilled = otp.every(d => d !== "");

  return (
    <div className="auth-screen" dir="rtl">
      <div className="auth-header">
        <button className="auth-back-btn" onClick={() => navigate('/password_recovery')}>
          <IoArrowForward size={20} />
        </button>
      </div>

      <div className="auth-content">
        <div className="auth-icon-hero">
          <div className="auth-icon-hero__circle">
            <IoKeyOutline size={34} />
          </div>
          <h1 className="auth-icon-hero__title">رمز التحقق</h1>
          <p className="auth-icon-hero__sub">أدخل الكود المُرسل إلى رقم هاتفك</p>
        </div>

        <div className="auth-otp-row" onPaste={handlePaste}>
          {otp.map((digit, i) => (
            <input
              key={i}
              className="auth-otp-box"
              type="text"
              inputMode="numeric"
              maxLength={1}
              value={digit}
              onChange={e => handleChange(e.target, i)}
              onKeyDown={e => handleKeyDown(e, i)}
              ref={el => (inputsRef.current[i] = el)}
            />
          ))}
        </div>

        <button className="auth-resend" onClick={() => navigate('/password_recovery')}>
          إعادة إرسال الكود
        </button>

        <button className="auth-submit" disabled={!isFilled} onClick={verifyOTP}>
          <IoCheckmarkOutline size={20} />
          تأكيد
        </button>
      </div>
    </div>
  );
}

export default PasswordOtpPage;
